"use strict";
/**
 * Per-client editing rules: which final sizes a concept gets and how files are
 * named. The settings page previews names with these helpers and the Shade
 * automations (concept folders, name checks) read the same ones, so the two
 * can never disagree about what a valid name or size is.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NEWFORM_EDITING_DEFAULTS = exports.EDITING_NAMING_EXAMPLE = exports.EDITING_NAMING_TOKEN_LABELS = exports.EDITING_NAMING_TOKENS = exports.EDITING_ASPECT_RATIOS = void 0;
exports.isEditingAspectRatio = isEditingAspectRatio;
exports.renderNamingPattern = renderNamingPattern;
exports.validateNamingPattern = validateNamingPattern;
/** Final sizes, spelled the way launch and file names spell them. */
exports.EDITING_ASPECT_RATIOS = ["9x16", "4x5", "1x1", "16x9"];
function isEditingAspectRatio(value) {
    return exports.EDITING_ASPECT_RATIOS.includes(value);
}
exports.EDITING_NAMING_TOKENS = [
    "date",
    "client",
    "batch",
    "variant",
    "part",
    "creator",
    "take",
    "size",
];
exports.EDITING_NAMING_TOKEN_LABELS = {
    date: "Delivery date, MMDD.YYYY",
    client: "Client name, no spaces",
    batch: "Batch number",
    variant: "Hook and body, e.g. H1B1",
    part: "Script part, e.g. H1, B2, CTA",
    creator: "Creator's first name",
    take: "Take, e.g. T2",
    size: "Size, e.g. 9x16",
};
/** Sample values for previews: one 18 Birdies batch. */
exports.EDITING_NAMING_EXAMPLE = {
    date: "1015.2026",
    client: "18Birdies",
    batch: "115",
    variant: "H1B1",
    part: "H1",
    creator: "Alen",
    take: "T2",
    size: "9x16",
};
/**
 * What every client starts on. Finals follow the names NewForm already ships
 * (e.g. NF_0625.2026_18Birdies88_Vid1_9x16.mp4), ending in the size so launch
 * can group the sizes of one ad.
 */
exports.NEWFORM_EDITING_DEFAULTS = {
    finalAspectRatios: ["9x16", "4x5"],
    finalsNaming: "NF_{date}_{client}{batch}_{variant}_{size}",
    footageNaming: "{client}{batch}_{part}_{creator}_{take}",
    includeConceptBroll: false,
};
const TOKEN_PATTERN = /\{([^{}]*)\}/g;
// Characters a file name can't hold on at least one of macOS, Windows or Drive.
const FORBIDDEN_CHARACTERS = /[/\\:*?"<>|]/;
function renderNamingPattern(pattern, values) {
    return pattern.replace(TOKEN_PATTERN, (match, token) => {
        const value = values[token];
        return value === undefined ? match : value;
    });
}
/** Plain-language problems with a naming pattern; empty when it's valid. */
function validateNamingPattern(pattern, kind) {
    const problems = [];
    const trimmed = pattern.trim();
    if (!trimmed)
        return ["Add a naming pattern."];
    if (trimmed !== pattern)
        problems.push("Remove spaces at the start or end.");
    const withoutTokens = pattern.replace(TOKEN_PATTERN, "");
    if (withoutTokens.includes("{") || withoutTokens.includes("}")) {
        problems.push("Every { needs a matching }.");
    }
    if (FORBIDDEN_CHARACTERS.test(withoutTokens)) {
        problems.push("Remove / \\ : * ? \" < > |, which file names can't hold.");
    }
    const tokens = [...pattern.matchAll(TOKEN_PATTERN)].map((m) => m[1]);
    for (const token of tokens) {
        if (!exports.EDITING_NAMING_TOKENS.includes(token)) {
            problems.push(`{${token}} isn't a field Framework knows.`);
        }
    }
    if (kind === "finals" && !pattern.endsWith("_{size}")) {
        problems.push("Finals names must end in _{size}, so launch can group the sizes of one ad.");
    }
    return problems;
}
